import { makeAutoObservable } from 'mobx';
import { searchToObject } from '../helpers/query';

const defaultLocation = { lat: 51.505, lng: -0.09 };
const square = 0.06;
defaultLocation.bounds = {
  lngMin: defaultLocation.lng - square,
  lngMax: defaultLocation.lng + square,
  latMin: defaultLocation.lat - square,
  latMax: defaultLocation.lat + square,
};
// const defaultLocation = { lat: 51.5248933, lng: -0.08715 };

const defaultFilter = {};

class SearchBrowserFilterState {
  constructor() {
    makeAutoObservable(this);
  }

  get defaultState() {
    return {
      location: {
        ...(this.userLocationState?.state || defaultLocation),
      },
      ...defaultFilter,
    };
  }

  isInitialized = false;

  stateSearch_ = null;

  get state() {
    return {
      ...this.defaultState,
      ...this.state_,
    };
  }

  get isDirty() {
    const defaultStateKeys = Object.keys(this.defaultState);
    const currentStateKeys = Object.keys(this.state);

    if (currentStateKeys.length > defaultStateKeys.length) return true;

    return JSON.stringify(this.defaultState) !== JSON.stringify(this.state);
  }

  get state_() {
    return this.stateSearch_ ? searchToObject(this.stateSearch_, true) : {};
  }

  init({ userLocationState }) {
    this.userLocationState = userLocationState;
    this.isInitialized = true;
  }

  update(search) {
    if (search !== this.stateSearch_) {
      this.stateSearch_ = search;
    }
  }

  destroy() {
    this.isInitialized = false;
  }
}

export default SearchBrowserFilterState;
